import { useMutation } from 'react-query';
import { axios } from '@/lib/axios';
import { useNotificationStore } from '@/stores/notifications';
import storage from '@/utils/storage';
import { API_URL } from '@/config';

export interface WorkflowApiConfigParam {
  path: string;
  label: string;
  demo_type: string;
  parameter_name: string;
  value_type: string;
  category: string;
  randomize: boolean;
}

export interface WorkflowPayload {
  description: string;
  api_config: {
    inputs: WorkflowApiConfigParam[];
    outputs: WorkflowApiConfigParam[];
    is_manual: boolean;
  };
}

export interface PatchWorkflowsRequest {
  project_id: string;
  workflow_id: string;
  payload: WorkflowPayload;
}

export const patchApiConfigInWorkflow = async ({
  project_id,
  workflow_id,
  payload,
}: PatchWorkflowsRequest): Promise<any> => {
  const access_token = storage.getToken();

  if (!access_token || !project_id) {
    return;
  }

  try {
    const response = await axios.patch(
      `${API_URL}/v2/project/${project_id}/workflows/${workflow_id}`,
      payload
    );
    return response;
  } catch (error) {
    // console.error('Error patchApiConfigInWorkfllow:', error);
    // throw error;
  }
};

export const usePatchApiConfigInWorkflow = (config = {}) => {
  const { addNotification } = useNotificationStore();

  return useMutation<any, Error, PatchWorkflowsRequest>(patchApiConfigInWorkflow, {
    onError: (error) => {
      addNotification({
        type: 'error',
        title: 'Failed to configure API Confguration',
        message: error.message,
      });
    },
    onSuccess(data) {
      if (data) {
        addNotification({
          type: 'success',
          title: 'API configuration saved',
        });
      }
    },
    ...config,
  });
};
